import { useFeatureValue } from '@frontend/react';
import { usePromoSlice } from '@frontend/redux';

export const useIsLinkedInPromo = (): boolean => {
  const { state } = usePromoSlice();
  const promoDetails = state?.promoDetails;
  const { value: linkedInPromotionEntityId } = useFeatureValue('linked_in_promotion_entity_id');
  return Boolean(linkedInPromotionEntityId && promoDetails?.promotionId === linkedInPromotionEntityId);
};
